// SEARCH FILTERS
(function () {
	//main wrapper
	const wrapper = document.getElementById("search-results");

	if (!wrapper) return;

	//container
	const container = document.getElementById("search__container");
	const header = document.getElementById("search-results__header");
	//filter forms
	const filtersForm = document.getElementById("filters-form");

	if (!container || !filtersForm) {
		console.error(
			`Container & filters form need to be defined for the filters & pagination to work`,
		);
		return;
	}

	const pageInput = filtersForm.querySelector('input[name="page"]');
	const hiddenInput = filtersForm.querySelector('input[name="s"]');

	if (!pageInput) {
		console.error(
			`Page input wasnt't found, this field is mandatory for the filters & pagination to work`,
		);
		return;
	}

	// Default
	const defaultPostTypes = wrapper.querySelector(
		'input[name="default-post-types"]',
	);

	// Sorting Select
	const sortingSelect = document.querySelector("#results_sorting");
	// Checkbox Filters
	const allCheckboxes = filtersForm.querySelectorAll('input[type="checkbox"]');
	// Checkboxes for Post Types
	const postTypesCheckBoxes = document.querySelectorAll(
		'input[name="post_type"]',
	);
	// Checkboxes for Products Taxonomy
	const productTaxCheckBoxes = document.querySelectorAll(
		'input[name="tax_product"]',
	);
	// Checkboxes for Disease Taxonomy
	const diseaseTaxCheckBoxes = document.querySelectorAll(
		'input[name="tax_disease"]',
	);
	// Checkboxes for Location Taxonomy
	const locationTaxCheckBoxes = document.querySelectorAll(
		'input[name="tax_location"]',
	);
	// Checkboxes for Years
	const yearsCheckBoxes = document.querySelectorAll('input[name="post_year"]');

	// Radio for Events
	const eventsRadio = document.querySelectorAll('input[name="events_show"]');

	// Get the search block input
	const searchInput = document.querySelector('input[name="search-input"]');
	const searchInputForm = document.querySelector(".search__form.--search-page");
	const isSearchResults = document.querySelector(".is-search-results");

	// Get preload search term
	const url = new URL(window.location.href);
	const t = url.searchParams.get("t");
	const preloadSearch = t !== null && t !== undefined ? t : "";

	// Check if there is search term from other pages, then run the filter
	if (t !== null && t !== undefined) {
		searchInput.value = preloadSearch;
		window.addEventListener("load", (e) => {
			updateSearch(preloadSearch);
			handleFilterChange(e);
		});
	}

	// Element to update with the results number after sending request
	const resultsNumber = wrapper.querySelector(".js-results-number");

	// Disable default submit for the form
	filtersForm.addEventListener("submit", (e) => {
		e.preventDefault();
	});

	// search input block disable submit
	searchInputForm.addEventListener("submit", (e) => {
		e.preventDefault();
	});

	// Search input event listener with 500ms debounce
	searchInput?.addEventListener(
		"input",
		debounce((e) => {
			updateSearch(e.target.value);
			handleFilterChange(e);
		}, 500),
	);

	// On filtering post types
	allCheckboxes?.forEach((checkbox) => {
		checkbox.addEventListener("change", (e) => handleFilterChange(e));
	});

	// Sorting
	sortingSelect?.addEventListener("change", (e) => {
		handleFilterChange(e);
	});

	// Events to show
	eventsRadio.forEach((radio) => {
		radio.addEventListener("change", (e) => handleFilterChange(e));
	});

	// FUNCTION TO HANDLE FILTER CHANGE
	async function handleFilterChange(e) {
		// Reset page back to page 1 when applying any type of filter
		pageInput.value = "1";

		// Load posts
		await loadPosts();
	}

	// FUNCTION TO LOAD POSTS
	async function loadPosts() {
		if (hiddenInput.value === "" && isSearchResults) {
			return;
		}

		container.classList.add("loading");
		// header.classList.add('loading');
		wrapper.classList.remove("is-not-search-results");

		// Get formData -- check helper function, it has extra logic for the multi-select fields
		const formData = getFiltersFormData();

		// Append action & nonce parameters
		formData.append("action", "filter_posts");
		formData.append("nonce", ajax_params.nonce);

		// Remove empty entries from formData
		const updatedFormData = removeEmptyEntriesFormData(formData);

		try {
			const response = await fetch(ajax_params.ajax_url, {
				method: "POST",
				body: updatedFormData,
			});

			if (response.ok) {
				const { success, data } = await response.json();
				const { resultsCount, content } = data;

				container.innerHTML = content;

				if (resultsNumber) {
					// Update Results Number element
					if (defaultPostTypes.value === "event") {
						resultsNumber.innerHTML = `${
							resultsCount === 1 ? "Event" : "Events"
						} <span>${resultsCount}</span>`;
					} else {
						resultsNumber.innerHTML = `${
							resultsCount === 1 ? "Result" : "Results"
						} <span>${resultsCount}</span>`;
					}
				}
			} else {
				console.error("Error:", response.status);
			}
		} catch (error) {
			console.error("Error:", error);
		} finally {
			wrapper.removeAttribute("style");
			container.classList.remove("loading");
			header.classList.remove("loading");
		}
	}

	// HELPER FUNCTIONS
	// Helper function to debounce input change
	function debounce(func, timeout = 300) {
		let timer;
		return (...args) => {
			clearTimeout(timer);
			timer = setTimeout(() => {
				func.apply(this, args);
			}, timeout);
		};
	}

	// Helper function to remove empty entries from formData object
	function removeEmptyEntriesFormData(formData) {
		const updatedFormData = new FormData();

		for (const [key, value] of formData.entries()) {
			if (value !== "") {
				updatedFormData.append(key, value);
			}
		}
		return updatedFormData;
	}

	// Helper function to get formData
	function getFiltersFormData() {
		// Get the form element with the ID "filtersForm"
		const formData = new FormData(filtersForm);

		// Get the Filtered Post Type
		const filteredPostTypes = filterCheckboxes(postTypesCheckBoxes);
		// Append filtered Post Type
		formData.append("post_type", filteredPostTypes);

		// Get the Filtered Product Tax
		const filteredProductTax = filterCheckboxes(productTaxCheckBoxes);
		// Append filtered Product Tax
		formData.append("product_tax", filteredProductTax);

		// Get the Filtered Disease Tax
		const filteredDiseaseTax = filterCheckboxes(diseaseTaxCheckBoxes);
		// Append filtered Disease Tax
		formData.append("disease_tax", filteredDiseaseTax);

		// Get the Filtered Location Tax
		const filteredLocationTax = filterCheckboxes(locationTaxCheckBoxes);
		// Append filtered Location Tax
		formData.append("location_tax", filteredLocationTax);

		// Get the Years Tax
		const filteredYears = filterCheckboxes(yearsCheckBoxes);
		// Append Years Tax
		formData.append("post_years", filteredYears);

		// Get Sorting
		if (sortingSelect) {
			formData.append("results_sorting", sortingSelect.value);
		}

		// Event show filter
		if (eventsRadio) {
			let selectedEventFilter = "";
			eventsRadio.forEach((radio) => {
				if (radio.checked) {
					const dataName = radio.getAttribute("data-name");
					selectedEventFilter = dataName;
				}
			});
			formData.append("events_show", selectedEventFilter);
		}

		// Return the updated form data
		return formData;
	}

	// Helper function to update the search hidden input - don
	function updateSearch(newSearch) {
		hiddenInput.value = newSearch;
	}

	// Helper function to filter checkboxes
	function filterCheckboxes(checkboxes) {
		const selectedValues = [];

		checkboxes.forEach((checkbox) => {
			if (checkbox.checked) {
				const dataName = checkbox.getAttribute("data-name");
				selectedValues.push(dataName);
			}
		});

		return selectedValues.join(", ");
	}

	// Helper function to scroll on the start of archive when applying filter
	function scrollToStart() {
		const headerHeight =
			getComputedStyle(document.documentElement).getPropertyValue(
				"--app-header-height",
			) || "93px";

		const { top } = container.getBoundingClientRect();

		const topPosition = top + window.scrollY - parseInt(headerHeight, 10) - 100;

		scrollTo({
			top: topPosition,
			behavior: "smooth",
		});
	}

	// PAGINATION
	wrapper.addEventListener("click", async (e) => {
		// Pagination
		if (e.target.closest(".pagination-button")) {
			e.preventDefault();

			const paginationButton = e.target.closest(".pagination-button");

			if (paginationButton.disabled) return;

			targetPage = paginationButton.getAttribute("data-page");
			if (!targetPage) {
				console.warn("Pagination Error, targetPage not found");
				return;
			}

			// Update page input
			pageInput.value = targetPage;

			// Load posts
			await loadPosts();

			// Scroll back at the start of the archive
			scrollToStart();
		}
	});

	//////////////// POSTY TYPE CHECKBOXES //////////

	function uncheckViewAll() {
		// If a checkbox other than "View All" is clicked, uncheck "View All"
		if (this !== document.getElementById("view-all")) {
			document.getElementById("view-all").checked = false;
		}
	}

	function unCheckAll() {
		const checkboxes = document.querySelectorAll('input[name="post_type"]');
		// If "View All" is checked, uncheck all other checkboxes
		if (this.checked) {
			checkboxes.forEach((checkbox) => {
				if (checkbox !== this) {
					checkbox.checked = false;
				}
			});
		}
	}

	function checkViewAllIfAllUnchecked() {
		const checkboxes = document.querySelectorAll('input[name="post_type"]');
		const viewAll = document.getElementById("view-all");

		// Check if all checkboxes are unchecked
		const allUnchecked = [...checkboxes].every((checkbox) => !checkbox.checked);

		// If all checkboxes are unchecked, check "View All"
		if (allUnchecked) {
			viewAll.checked = true;
		}
	}

	const postTypes = document.querySelectorAll('input[name="post_type"]');
	const viewAll = document.getElementById("view-all");

	// Add an event listener to each checkbox
	postTypes.forEach((checkbox) => {
		checkbox.addEventListener("click", uncheckViewAll);
		checkbox.addEventListener("click", checkViewAllIfAllUnchecked);
	});

	// Add an event listener to the "View All" checkbox
	viewAll?.addEventListener("click", unCheckAll);
	viewAll?.addEventListener("click", checkViewAllIfAllUnchecked);
})();
